import { Module } from '@nestjs/common';
import { appSettings } from '../../../config';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExpensesModule } from './expenses/expenses.module';
import { ExpensesCategory } from './expenses-category/expenses-category.entity';
import { ExpensesCategoryModule } from './expenses-category/expenses-category.module';
import { ExpensesSubCategoryModule } from './expenses-sub-category/expenses-sub-category.module';
import { HolidaysCalenderModule } from './holidays-calender/holidays-calender.module';
import { IdProofsModule } from './id-proofs/id-proofs.module';
import { LoanCategoriesModule } from './loan-categories/loan-categories.module';
import { OvertimeCategoryModule } from './overtime-category/overtime-category.module';
import { OverTimeCategory } from './overtime-category/overtime-category.entity';
import { LoanCategory } from './loan-categories/loan-categories.entity';
import { QualificationModule } from './qualification/qualification.module';
import { RecruitmentModule } from './recruitment/recruitment.module';
import { RelationsModule } from './relations/relations.module';

// import { SuggestionsService } from './suggestions/suggestions.service';
import { SuggestionsModule } from './suggestions/suggestions.module';
import { ExpensesSubCategory } from './expenses-sub-category/expenses-sub-category.entity';
import { ExpensesCategoryService } from './expenses-category/expenses-category.service';
import { ExpensesSubCategoryService } from './expenses-sub-category/expenses-sub-category.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Suggestions } from './suggestions/suggestions.entity';
import { ComplaintsModule } from './complaints/complaints.module';
import { ComplaintsEntity } from './complaints/complaints.entity';
import { SkillsModule } from './skills/skills.module';
import { Skills } from './skills/skills.entity';
import { PickupModule } from './pickup/pickup.module';
import { PickUp } from './pickup/pickup.entity';
import { HolidaysCalendar } from './holidays-calender/holidays-calendar.entity';
import { EmploymentStatusModule } from './employment-status/employment-status.module';
import { EmploymentStatus } from './employment-status/employment-status.entity';
import { TransferActionModule } from './transfer-action/transfer-action.module';
import { TransferAction } from './transfer-action/transfer-action.entity';
import { TypesOfLeavesModule } from './types-of-leaves/types-of-leaves.module';
import { TypesOfLeaves } from './types-of-leaves/types-of-leaves.entity';
import { EmployeeLeavesModule } from './employee-leaves/employee-leaves.module';
import { ExitActionService } from './exit-action/exit-action.service';
import { ExitActionController } from './exit-action/exit-action.controller';
import { ExitActionModule } from './exit-action/exit-action.module';
import { ExitAction } from './exit-action/exit-action.entity';
import { CertificationsModule } from './certifications/certifications.module';
import { EducationModule } from './education/education.module';
import { Education } from './education/education.entity';
import { Certifications } from './certifications/certifications.entity';
import { ProfilesModule } from './profiles/profiles.module';
import { NotificationsModule } from './notifications/notifications.module';
import { ApplyForLeavesModule } from './apply-for-leaves/apply-for-leaves.module';
import { Profiles } from './profiles/profiles.entity';
import { Notifications } from './notifications/notifications.entity';
import { ApplyForLeaves } from './apply-for-leaves/apply-for-leaves.entity';
import { LeaveApprovalModule } from './leave-approval/leave-approval.module';
import { RecruitmentActivitiesModule } from './recruitment-activities/recruitment-activities.module';
import { RecruitmentActivities } from './recruitment-activities/entity/recruitment-activities.entity';
import { Expenses } from './expenses/entity/expenses-entity';
import { InterviewModule } from './interview/interview.module';
import { DesignationActionModule } from './designation-action/designation-action.module';
import { Interview } from './interview/interview.entity';
import { EmployeeLeaves } from './employee-leaves/entity/employee-leaves.entity';
import { DesignationAction } from './designation-action/designation-action.entity';
import { DesignationModule } from './designation/designation.module';
import { Designation } from './designation/designation.entity';
import { AttendanceModule } from './attendance/attendance.module';
import { AttendanceLogEntity } from './attendance/entities/attendance-log.entity';
import { AttendanceEntity } from './attendance/entities/attendance.entity';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import { AttendanceService } from './attendance/attendance.service';
import { ScheduleModule } from '@nestjs/schedule';
import { Contractor } from './human-resource-agent/entity/human-resource-agent.entity';
import { ContractorModule } from './human-resource-agent/human-resource-agent.module';
import { TeamsEntity } from './teams/entities/teams.entity';
import { TeamModule } from './teams/teams.module';
import { ShiftsEntity } from './shifts/entities/shifts.entity';
import { ShiftModule } from './shifts/shifts.module';
import { EmployeeTeamEntity } from './employee-team/entity/employee-team.entity';
import { EmployeeTeamModule } from './employee-team/employee-team.module';
import { TeamCalender } from './team-calender/entity/team-calender.entity';
import { TeamCalenderModule } from './team-calender/team-calender.module';
import { WorkCalender } from './work-calender/entity/work-calender.entity';
import { WorkCalenderModule } from './work-calender/work-calender.module';
import { UploadDetailesModule } from './HRMS-Upload-Detailes/upload.detailes.module';
import { UploadDetailesEntity } from './HRMS-Upload-Detailes/Dto/upload.detailes.entity';
import { AttendanceAdjustment } from './attendance/entities/attendance-adjustment.entity';
import { EmployeeTypesModule } from './employee-type/employee-type.module';
import { EmployeeTypes } from './employee-type/employee-type.entity';
import { OverTimeEntity } from './over-time/over-time.entity';
import { OvertimeModule } from './over-time/over-time.module';
import { RouteModule } from './routes/route.module';
import { Route } from './routes/entity/route.entity';
import { HolidaysCalendarLog } from './holidays-calender/holidays-calendar-log.entity';
import { ApplyForLeavesLog } from './apply-for-leaves/apply-for-leaves-log.entity';
import { EmployeeWeekOffUploadsModule } from './employee-week-off-uploads/employee-week-off-uploads.module';
import { employeeWeekOfUploadsLog } from './employee-week-off-uploads/employee-week-off-uploads-log.entity';
import { employeeWeekOfUploads } from './employee-week-off-uploads/employee-week-off-uploads.entity';
import { ConsolidatedAttendanceLogEntity } from './attendance/entities/consoladate-attendance-logs.entity';
import { EmployeeLeavesLog } from './employee-leaves/entity/employee-leaves-log.entity';
import { ApplyCoOdLeaves } from './apply-for-leaves/apply-for-od-co.entity';
import { PayrollProcessModule } from './payroll/payroll-process.module';
import { PayrollComponentsLogs } from './payroll/entity/payroll-process-logs.entity';
import { PayrollComponents } from './payroll/entity/payroll-process.entity';
import { PayrollLogs } from './payroll/entity/payroll-log';

@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.hrms_db,
      entities: [OverTimeCategory, LoanCategory, ExpensesCategory, ExpensesSubCategory, Suggestions, ComplaintsEntity, Skills, HolidaysCalendar, EmploymentStatus, TransferAction, TypesOfLeaves, ExitAction, Education, Certifications, Notifications, Profiles, ApplyForLeaves, RecruitmentActivities, Expenses, Interview, EmployeeLeaves, DesignationAction, Designation, AttendanceEntity, AttendanceLogEntity, Contractor, TeamsEntity, ShiftsEntity, EmployeeTeamEntity, TeamCalender, WorkCalender, UploadDetailesEntity, PickUp, AttendanceAdjustment, EmployeeTypes, OverTimeEntity, Route,HolidaysCalendarLog,ApplyForLeavesLog,employeeWeekOfUploads,employeeWeekOfUploadsLog,EmployeeLeavesLog,ConsolidatedAttendanceLogEntity,ApplyCoOdLeaves,PayrollComponentsLogs,PayrollComponents,PayrollLogs],
      synchronize: false,
      logging: true
    }),
    ExpensesModule, ExpensesCategoryModule, ExpensesSubCategoryModule, HolidaysCalenderModule, IdProofsModule, LoanCategoriesModule, OvertimeCategoryModule, QualificationModule, RecruitmentModule, RelationsModule, ShiftModule, SuggestionsModule, ComplaintsModule, SkillsModule, EmploymentStatusModule, TransferActionModule, TypesOfLeavesModule, ExitActionModule, CertificationsModule, EducationModule, ProfilesModule, ApplyForLeavesModule, NotificationsModule, LeaveApprovalModule, RecruitmentActivitiesModule, InterviewModule, DesignationActionModule, EmployeeLeavesModule, DesignationModule, AttendanceModule, ContractorModule, TeamModule, EmployeeTeamModule, TeamCalenderModule, WorkCalenderModule, UploadDetailesModule, PickupModule, EmployeeTypesModule, OvertimeModule, RouteModule,EmployeeWeekOffUploadsModule,PayrollProcessModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
